import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

/** Página exibida quando o usuário autenticado não tem permissão para a rota acessada. */
@Component({
    selector: 'app-sem-acesso',
    standalone: true,
    imports: [RouterLink],
    template: `
        <div class="w-full min-h-[70vh] flex items-center justify-center p-6">
            <div class="w-full max-w-lg flex flex-col items-center text-center gap-6 px-8 py-12 rounded-3xl bg-surface-0 dark:bg-surface-900 border border-surface-200 dark:border-surface-700 shadow-sm">
                <div class="relative flex items-center justify-center">
                    <div class="absolute inset-0 bg-primary/20 blur-2xl rounded-full"></div>
                    <div class="relative w-24 h-24 flex items-center justify-center rounded-full bg-primary/10 text-primary">
                        <i class="pi pi-lock !text-4xl"></i>
                    </div>
                </div>

                <div class="flex flex-col gap-3">
                    <h1 class="text-3xl font-extrabold m-0 tracking-tight">Sem acesso</h1>
                    <p class="text-muted-color text-lg leading-relaxed m-0 max-w-md">Você não tem permissão para acessar esta área do SICOM. Se acredita que isso é um engano, fale com o administrador do sistema.</p>
                </div>

                <a routerLink="/" class="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary text-white font-semibold no-underline shadow-sm transition-opacity hover:opacity-90">
                    <i class="pi pi-home"></i>
                    <span>Voltar ao início</span>
                </a>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SemAcesso {}
